module.exports = __webpack_public_path__ + "img/img34.3b22eb44.svg";